import React from "react";
import { Dialog } from "@smartsuite/react-ui/lib/components/modals/Dialog";
import { ModalOverlay } from "@smartsuite/react-ui/lib/components/modals/ModalOverlay/ModalOverlay";
import { text } from "./MenuView.text";
export const DeleteTableDialog = ({ active, onConfirm, onCancel, }) => {
    return (React.createElement(ModalOverlay, { active: active, onClose: onCancel },
        React.createElement(Dialog.Wrapper, { type: "warning", onCancel: onCancel },
            React.createElement(Dialog.Image, { background: "red", url: "assets/images/question.svg" }),
            React.createElement(Dialog.Header, null,
                React.createElement(Dialog.Header.Heading, { text: text.confirmDialog.title }),
                React.createElement(Dialog.Header.Description, { text: text.confirmDialog.description })),
            React.createElement(Dialog.Footer, null,
                React.createElement(Dialog.Footer.CancelButton, { text: text.confirmDialog.cancel, onClick: onCancel }),
                React.createElement(Dialog.Footer.ConfirmButton, { warningBackground: true, text: text.confirmDialog.confirm, onClick: onConfirm })))));
};
